import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, SmBaseService } from '../../core';

@Injectable()
export class FeedbackTemplateService extends SmBaseService {
	constructor(http: HttpService) {
		super(http, 'feedbackTemplate');
	}

	getAll(): Observable<FeedbackTemplateModel[]> {
		return this._getAs<FeedbackTemplateModel[]>();
	}

	get(templateId: number): Observable<FeedbackTemplateModel> {
		return this._getAs<FeedbackTemplateModel>(templateId);
	}

	delete(templateId: number): Observable<any> {
		return this._delete(templateId);
	}

	add(model: FeedbackTemplateModel): Observable<any> {
		return this._post('', model);
	}

	update(templateId: number, model: FeedbackTemplateModel): Observable<any> {
		return this._put(templateId, model);
	}
}

export class FeedbackTemplateModel {
	id: number;
	name: string;
	code: string;
	feedback: string;
	feedbackType: FeedbackType;
	isSystem: boolean;
}

export enum FeedbackType {
	Positive = 1,
	Neutral = 2,
	Negative = 3
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/feedback-template.service.ts